<div class="modal-drawer" oxDrawerModal>
  <div>
    <!-- Header Row -->
    <div class="row">
      <div class="col-12">
        <!-- MODAL HEADER ROW -->
        <div class="page-header-button">
          <div
            class="gb-headline1"
            role="heading"
            aria-level="1"
            [translate]="'takata_recallModalHeader'"
          ></div>
          <span
            [trackLink]="'Takata Recall:Close'"
            [trackDelay]="'true'"
            trackType="o"
            prop10="Recall Notifications:button:close">
            <button
              class="close-modal"
              (click)="modalRef.hide()"
              aria-hidden="false"
              [attr.aria-label]="'aoda_close_modal_label' | translate">
              <span
                class="icon-ui-closedot gb-body1"
                role="presentation">
              </span>
            </button>
          </span>
        </div>
      </div>
    </div>

    <!-- Takata Opt Ins Form Row -->
    <div class="row">
      <div class="col-12">
        <div class="gb-body1 pb-6" [translate]="'takata_recallModalCopy'"></div>
      </div>
      <div class="col-12 col-md-7 offset-md-1">
        <div
          class="gb-headline3 mb-4"
          [translate]="'takata_recallModalSubheader'"
        ></div>
        <!-- Name -->
        <div class="mb-4 row clearfix">
          <div class="col-12 col-md-2">
            <div
              class="gb-body1 heavy"
              [translate]="'takata_recallSignupFormName'">
            </div>
          </div>
          <form class="col-12 col-md-10" [formGroup]="customerNameForm">
            <div class="form-group">
              <!-- First Name Input -->
              <ox-text-input
                id="firstName"
                inputName="firstName"
                classes="form-control"
                type="text"
                validationType="nameCharacters"
                required="true"
                [formGroupInput]="customerNameForm"
                [pattern]="firstNameAttributes.pattern.source"
                formControlNameInput="firstName"
                placeHolderText="First Name"
                ariaLabel="First Name">
              </ox-text-input>
            </div>
            <div class="form-group">
              <!-- Last Name Input -->
              <ox-text-input
                id="lastName"
                inputName="lastName"
                classes="form-control"
                type="text"
                validationType="nameCharacters"
                required="true"
                [formGroupInput]="customerNameForm"
                [pattern]="lastNameAttributes.pattern.source"
                placeHolderText="Last Name"
                formControlNameInput="lastName"
                ariaLabel="Last Name">
              </ox-text-input>
            </div>
          </form>
        </div>

        <!-- Mail -->
        <div class="mailOptInRow row pb-4">
          <div class="col-12">
            <ul class="checkbox-list mb-0">
              <li>
                <div
                  class="gb-checkbox"
                  [trackLink]="'Takata Recall:Notification Method Mail'"
                  [trackDelay]="'true'"
                  trackType="o"
                  [prop10]="'Recall Notifications:checkbox:mail option: {{mailCheckBox.value}}'"
                  [trackDropdown]="'true'">
                  <input
                    id="mailSignupId"
                    type="checkbox"
                    [formControl]="mailCheckBox"
                  />
                  <label
                    for="mailSignupId"
                    [translate]="'takata_recallSignupFormMail'"
                  ></label>
                </div>
              </li>
            </ul>
          </div>
          <!-- End Mail OptIn Row -->
          <div [hidden]="!this.mailCheckBox.value"
            [translate]="'takata_recallNoAddressDisclaimer'">
          </div>
          <div class="gb-body1 col-12" [hidden]="!mailCheckBox.value">
            <form class="heavy" [formGroup]="customerAddressForm">
              <!-- Street Address Input-->
              <div class="mb-4 clearfix">
                <div class="form-group">
                  <ox-text-input
                    [id]="'address1'"
                    [inputName]="'address1'"
                    classes="form-control"
                    type="text"
                    [formGroupInput]="customerAddressForm"
                    formControlNameInput="address1"
                    [pattern]="addressAttributes.pattern.source"
                    [maxLength]="addressAttributes.maxlength"
                    [required]="true"
                    [placeHolderText]="'takata_recallSignupFormAddress' | translate"
                    [label]="'takata_recallSignupFormAddress'"
                    [placeHolderId]="'takata_recallSignupFormAddress'">
                  </ox-text-input>
                </div>
                <div class="form-group">
                  <ox-text-input
                    [id]="'address2'"
                    [inputName]="'address2'"
                    classes="form-control"
                    type="text"
                    [formGroupInput]="customerAddressForm"
                    formControlNameInput="address2"
                    [pattern]="addressAttributes.pattern.source"
                    [required]="false"
                    [maxLength]="addressAttributes.maxlength"
                    [placeHolderText]="'takata_recallSignupFormAddress' | translate"
                    [label]="'takata_recallSignupFormAddress'"
                    [placeHolderId]="'takata_recallSignupFormAddress'">
                  </ox-text-input>
                </div>
              </div>
              <!-- City Input -->
              <div class="mb-4 clearfix">
                <div class="form-group">
                  <ox-text-input
                    [id]="'city'"
                    [inputName]="'city'"
                    classes="form-control"
                    [type]="'text'"
                    validationType="nameCharacters"
                    [required]="true"
                    [maxLength]="cityAttributes.maxlength"
                    [placeHolderText]="'city'"
                    [formGroupInput]="customerAddressForm"
                    formControlNameInput="city"
                    [pattern]="cityAttributes.pattern.source"
                    [label]="'takata_recallSignupFormCity'"
                    [placeHolderId]="'takata_recallSignupFormCity'"
                  >
                  </ox-text-input>
                </div>
              </div>
              <!-- State Dropdown -->
              <div class="mb-4 clearfix">
                <div
                  class="form-group"
                  [trackLink]="'Takata Recall:Notification Mail State'"
                  [trackDropdown]="'true'"
                  [trackDelay]="'true'"
                  trackType="o"
                  [prop10]="'Recall Notifications:Dropdown:State: {{selectedState}}'">
                  <div class="gb-dropdown">
                    <div class="gb-input">
                      <label for="stateProvince">
                        <span [translate]="'takata_recallSignupFormState'"></span>
                      </label>
                      <div class="gb-select-container">
                        <select *ngIf="states" (change)="updateStateProvince()" formControlName="stateName">
                          <option id="stateProvince" *ngFor="let state of states | keyvalue" [ngValue]="state.value">
                            {{ state.value }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Zip Code Input -->
              <div class="mb-4 clearfix">
                <div class="form-group">
                  <ox-text-input
                    [id]="'takata_recallSignupFormZipCode'"
                    inputName="zip code"
                    classes="form-control"
                    [type]="'text'"
                    validationType="postalCode"
                    [required]="zipAttributes.required"
                    [formGroupInput]="customerAddressForm"
                    formControlNameInput="zipCode"
                    [maxLength]="zipAttributes.maxlength"
                    [minLength]="zipAttributes.minlength"
                    [pattern]="zipAttributes.pattern.source"
                    [placeHolderText]="'takata_recallSignupFormZipCode'"
                    [label]="'takata_recallSignupFormZipCode'"
                    [placeHolderId]="'takata_recallSignupFormZipCode'">
                  </ox-text-input>
                </div>
              </div>
            </form>
          </div>
        </div>

        <!-- Voice -->
        <div class="voiceOptInRow row pb-4">
          <div>
            <div class="col-12">
              <!-- Voice Check Box-->
              <ul class="checkbox-list mb-0">
                <li>
                  <div
                    class="gb-checkbox"
                    [trackLink]="'Takata Recall:Notification Method Voice'"
                    [trackDelay]="'true'"
                    trackType="o"
                    [prop10]="'Recall Notifications:checkbox:phone option:{{voiceCheckBox.value}}'"
                    [trackDropdown]="'true'">
                    <input
                      id="voiceSignupId"
                      type="checkbox"
                      [formControl]="voiceCheckBox"/>
                    <label
                      for="voiceSignupId"
                      [translate]="'takata_recallSignupFormVoice'">
                    </label>
                  </div>
                </li>
              </ul>
            </div>
            <div [hidden]="!voiceCheckBox.value">
              <div class="col-12">
                <div class="mb-4 clearfix">
                  <form [formGroup]="customerVoicePhoneForm">
                    <div class="form-group">
                      <!-- Voice Phone number Input -->
                      <ox-text-input
                        [id]="'voicePhone'"
                        [inputName]="'voicePhone'"
                        classes="form-control"
                        type="text"
                        [validationType]="'phone'"
                        [required]="true"
                        [maxLength]="phoneNumberAttributes.maxlength"
                        [pattern]="phoneNumberAttributes.pattern.source"
                        [formGroupInput]="customerVoicePhoneForm"
                        [formControlNameInput]="'voicePhone'"
                        [label]="'takata_recallSignupFormPhone'"
                        [placeHolderId]="'takata_recallSignupFormPhone'">
                      </ox-text-input>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <!-- end row voiceOptInRow -->
        </div>

        <!-- Text -->
        <div class="textOptInRow row pb-4">
          <div>
            <div class="col-12">
              <ul class="checkbox-list mb-0">
                <li>
                  <div
                    class="gb-checkbox"
                    [trackLink]="'Takata Recall:Notification Method Text'"
                    [trackDelay]="'true'"
                    trackType="o"
                    [prop10]="'Recall Notifications:checkbox:text option:{{textCheckBox.value}}'"
                    [trackDropdown]="'true'">
                    <input
                      id="textSignupId"
                      type="checkbox"
                      [formControl]="textCheckBox"/>
                    <label
                      for="textSignupId"
                      [translate]="'takata_recallSignupFormText'">
                    </label>
                  </div>
                </li>
              </ul>
            </div>

            <div [hidden]="!textCheckBox.value">
              <div class="col-12 col-md-10">
                <div class="mb-4 clearfix">
                  <form [formGroup]="customerTextPhoneForm">
                  <!--  Text Phone Input  -->
                    <div class="form-group">
                      <ox-text-input
                        [id]="'textPhone'"
                        [inputName]="'textPhone'"
                        classes="form-control"
                        type="text"
                        [validationType]="'phone'"
                        [required]="true"
                        [maxLength]="phoneNumberAttributes.maxlength"
                        [pattern]="phoneNumberAttributes.pattern.source"
                        [formGroupInput]="customerTextPhoneForm"
                        formControlNameInput="textPhone"
                        [label]="'takata_recallSignupFormPhone'"
                        [placeHolderId]="'takata_recallSignupFormPhone'">
                      </ox-text-input>
                    </div>
                  </form>
                  <div
                    class="gb-body1"
                    [innerHTML]="'takata_recallPhoneDisclaimer' | translate"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <!-- end row textOptInRow -->
        </div>

        <!-- Email -->
        <div class="emailOptInRow row pb-4">
          <div>
            <!-- Email OptIn Checkbox-->
            <div class="col-12">
              <ul class="checkbox-list mb-0">
                <li>
                  <div
                    class="gb-checkbox"
                    trackLink="Takata Recall:Notification Method Email"
                    trackDelay="true"
                    trackType="o"
                    [prop10]="'Recall Notifications:checkbox:email option:{{emailCheckBox.value}}'"
                    trackDropdown="true">
                    <input
                      id="emailSignupId"
                      type="checkbox"
                      [formControl]="emailCheckBox"/>
                    <label
                      for="emailSignupId"
                      [translate]="'takata_recallSignupFormEmail'">
                    </label>
                  </div>
                </li>
              </ul>
            </div>
            <!-- Email text Input-->
            <div class="col-12" [hidden]="!emailCheckBox.value">
              <div class="mb-4 clearfix">
                <form [formGroup]="customerEmailForm">
                  <div class="form-group">
                    <ox-text-input
                      [id]="'emailAddress'"
                      [inputName]="'emailAddress'"
                      classes="form-control"
                      [type]="'text'"
                      [validationType]="'email'"
                      [maxLength]="+emailAddressAttributes.maxlength"
                      [required]="true"
                      [formGroupInput]="customerEmailForm"
                      [pattern]="emailAddressAttributes.pattern.source"
                      formControlNameInput="emailAddress"
                      [label]="'takata_recallSignupFormEmail'"
                      [placeHolderId]="'takata_recallSignupFormEmail'"
                      [minLength]="+emailAddressAttributes.minlength">
                    </ox-text-input>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <!-- end row emailOptInRow -->
        </div>

        <!-- Radio Buttons -->
        <div class="row">
          <div class="col-12 col-md-10 mb-6 mt-6">
            <div class="mb-6">
              <label
                class="gb-headline3 mb-6 pl-4 ml-4"
                [translate]="'takata_recallSignupFormOwnerDriver'"
              ></label>
              <div [formGroup]="ownerAndDriverRadioOptForm">
                <div class="row">
                  <div class="col-12" *ngFor="let ownerDriverOption of ownerDriverRadioOptions">
                    <div
                      [trackLink]="'Takata Recall:Vehicle Possession'"
                      [trackDelay]="'true'"
                      trackType="o"
                      prop10="Recall Notifications:click:{{ownerDriverOption.prop10}}"
                      trackDropdown="true">
                      <div class="gb-radio">
                        <input
                          type="radio"
                          [id]="ownerDriverOption.id"
                          formControlName="ownerDriver"
                          [value]="ownerDriverOption.value"
                        />
                        <label
                          [translate]="ownerDriverOption.label"
                          [attr.for]="ownerDriverOption.id"
                        ></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <!-- Vehicle Info Box -->
        <div class="row">
          <div class="col-12">
            <div class="card card-default">
              <div class="card-heading">
                <div class="card-title">
                  <div
                    class="gb-headline2"
                    role="heading"
                    aria-level="2"
                    [translate]="'takata_recallInfoboxHeader'"
                  ></div>
                </div>
              </div>
              <div class="card-bg-extend-border gray-light gb-body1">
                <div class="row pb-4">

                  <div
                    class="heavy col-12 col-sm-4"
                    [translate]="'takata_recallInfoboxRecallNum'"
                    [translateParams]="{ recall: takataRecallNums }"
                  >
                  </div>
                </div>
                <div class="row pb-4">
                  <div
                    class="heavy col-12 col-sm-4"
                    [translate]="'takata_recallInfoboxYMM'"
                    [translateParams]="{
                      vehicleYear: vehicleYear,
                      vehicleMake: vehicleMake,
                      vehicleModel: vehicleModel
                    }"
                  >
                  </div>
                </div>
                <div class="row">
                  <div
                    class="heavy col-12 col-sm-4"
                    [translate]="'takata_recallInfoboxVin'"
                    [translateParams]="{ vin: vin }"
                  >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end of Vehicle Info Box -->
      </div>
    </div>

    <!-- Save / Cancel Buttons Row -->
    <div class="row">
      <div class="col-12">
        <div class="modal-footer-content mb-8">
          <div class="row">
            <!-- Cancel Button -->
            <div class="col-12 col-md-3 offset-md-6">
              <button
                class="gb-secondary-button ml-6 mt-4 float-right"
                (click)="cancelTakataSignup()">
                <span [translate]="'takata_recallSignupFormCancel'"></span>
              </button>
            </div>
            <!-- Save Button-->
            <div class="col-12 col-md-3">
              <button
                class="gb-primary-button ml-6 mt-4 float-right"
                [ngClass]="{'disabled': customerNameForm.invalid || (mailCheckBox.value && customerAddressForm.invalid) || (voiceCheckBox.value && customerVoicePhoneForm.invalid) || (textCheckBox.value && customerTextPhoneForm.invalid) || (emailCheckBox.value && customerEmailForm.invalid) || (!mailCheckBox.value && !voiceCheckBox.value && !textCheckBox.value && !emailCheckBox.value)}"
                (click)="saveTakataSignup()"
                [trackLink]="'Takata Recall:Save'"
                [trackDelay]="'true'"
                trackType="o"
                prop10="Recall Notifications:button:save">
                <span [translate]="'takata_recallSignupFormSave'"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
